import type { FooterColumn, NavLink, Stat } from '../types/content'

export const site = {
  name: 'ShreyasStudio',
  shortName: 'ShreyasStudio',
  email: 'studio@shreyaspawar.com',
  phone: '+91 90965 93101',
  phoneHref: 'tel:+919096593101',
  location: 'India — working remotely with clients across India',
  locationShort: 'India',
}

export const primaryNav: NavLink[] = [
  { label: 'Work', to: '/work' },
  { label: 'Services', to: '/services' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'About', to: '/about' },
]

export const footerColumns: FooterColumn[] = [
  {
    title: 'Sitemap',
    links: [
      { label: 'Home', to: '/' },
      { label: 'Work', to: '/work' },
      { label: 'Services', to: '/services' },
      { label: 'Pricing', to: '/pricing' },
      { label: 'About', to: '/about' },
      { label: 'Contact', to: '/contact' },
    ],
  },
  {
    title: 'Services',
    links: [
      { label: 'Brand & identity', to: '/services' },
      { label: 'Website design', to: '/services' },
      { label: 'Development & build', to: '/services' },
      { label: 'E-commerce', to: '/services' },
      { label: 'Care & growth', to: '/services' },
    ],
  },
]

// Placeholder URLs — replace each with the studio's real profile handle before publishing.
export const socialLinks: NavLink[] = [
  { label: 'Instagram', to: 'https://instagram.com' },
  { label: 'LinkedIn', to: 'https://linkedin.com' },
  { label: 'Dribbble', to: 'https://dribbble.com' },
  { label: 'Behance', to: 'https://behance.net' },
]

export const buildTools: string[] = [
  'Figma',
  'Webflow',
  'Framer',
  'Next.js',
  'Shopify',
  'WordPress',
]

export const operationalStats: Stat[] = [
  { value: '1 day', label: 'Reply to every enquiry, on working days' },
  { value: 'Fixed price', label: 'Agreed in writing before work starts' },
  { value: '50%', label: 'Deposit to start, the rest on launch' },
  { value: '30 days', label: 'Post-launch support, no extra charge' },
]
